<div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
  <div class="space-y-4">
    <div class="rounded border border-neutral-300 dark:border-neutral-700 p-3">
      <div class="font-semibold mb-2">Informações do SKU</div>
      <div class="flex flex-wrap items-center gap-3 mb-2">
        <app-badge-status
          [status]="sku.isActive"
          messageTrue="Ativo"
          messageFalse="Inativo"
        ></app-badge-status>
        @if (!sku.isBrandActive) {
        <app-badge icon="x" type="danger"> Marca inativa </app-badge>
        }
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
        <div>
          <div>SkuID</div>
          <div class="font-medium">{{ sku.id }}</div>
        </div>
        <div>
          <div>Nome do SKU</div>
          <div class="font-medium">{{ sku.skuName }}</div>
        </div>
        <div>
          <div>RefID</div>
          <div class="font-medium">{{ sku.productRefId || '-' }}</div>
        </div>
        <div>
          <div>Peso (g)</div>
          <div class="font-medium">
            {{
              sku.stockKeepingUnitRealDimension?.realWeight || sku.dimension?.weight || '-'
            }}
          </div>
        </div>
        <div>
          <div>Dimensões (C x L x A)</div>
          <div class="font-medium">
            {{
              sku.stockKeepingUnitRealDimension?.realLength || sku.dimension?.length || '-'
            }}
            x
            {{
              sku.stockKeepingUnitRealDimension?.realWidth || sku.dimension?.width || '-'
            }}
            x
            {{
              sku.stockKeepingUnitRealDimension?.realHeight || sku.dimension?.height || '-'
            }}
          </div>
        </div>
      </div>

      @if (sku.skuSellers.length > 0) {
      <hr class="my-3" />
      <div class="font-semibold my-2">Sellers</div>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
        @for (seller of sku.skuSellers; track seller) {
        <div>
          <div>ID</div>
          <div class="font-medium">{{ seller.sellerId }}</div>
        </div>
        <div>
          <div>Ativo</div>
          <div class="font-medium">{{ seller.isActive }}</div>
        </div>
        } @empty {
        <div class="text-center text-neutral-500">
          Nenhum seller encontrado para este SKU.
        </div>
        }
      </div>
      } @if (sku.skuSpecifications.length > 0) {
      <hr class="my-3" />
      <div class="font-semibold my-2">Especificações</div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
        @for (spec of skuSpecifications | keyvalue; track spec) {
        <div>
          <div>{{ spec.key }}</div>
          <div class="font-medium">{{ spec.value.join(', ') }}</div>
        </div>
        }
      </div>
      }
    </div>
  </div>

  <div class="space-y-4">
    <app-image-carousel [images]="getSkuImages()" [interval]="5000"></app-image-carousel>
  </div>
</div>
